import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import ResponsiveImage from 'components/images/responsive-image'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { splitTextWith } from 'lib/utils/common/commonUtils'
import env from 'config/env'
import Typo from 'constants/typography'
import Timer from './timer'

const STATIC_CONTENTS = {
  pomeloGirlsHome: {
    en: {
      src: `${env.IMG_HOST}img/pomelo-cares/pomelo_girls_home_en.svg`,
      ratio: 0.0892857143,
    },
    th: {
      src: `${env.IMG_HOST}img/pomelo-cares/pomelo_girls_home_en.svg`,
      ratio: 0.0892857143,
    },
    id: {
      src: `${env.IMG_HOST}img/pomelo-cares/pomelo_girls_home_en.svg`,
      ratio: 0.0892857143,
    },
  },
  lineHome: {
    src: `${env.IMG_HOST}img/pomelo-cares/line_home.svg`,
    ratio: 0.170731707,
  },
  imagesBlock: {
    src: `${env.IMG_HOST}img/pomelo-cares/images_block.jpg`,
    ratio: 1,
  },
}

const PinkSection = ({ initialTime, language, serverTime, t }) => {
  const lastTextBody = splitTextWith(
    hasLocizeTranslation(
      t,
      'POMELO_CARE_PINK_GIRLS_HOME_FOOTER',
      `Show us how you’re spending time at home!
Tag %b%#pomelogirlsathome%b% on Instagram`,
    ),
    '%b%',
  )

  return (
    <section className="pomelo-cares-pink">
      <ResponsiveImage
        className="pomelo-girls-home"
        src={STATIC_CONTENTS.pomeloGirlsHome[language].src}
        imgRatio={STATIC_CONTENTS.pomeloGirlsHome[language].ratio}
      />
      <span className={clsx(Typo.body2, 'text-girls-home-body')}>
        {hasLocizeTranslation(
          t,
          'POMELO_CARE_PINK_GIRLS_HOME_BODY',
          `Social Distancing is Key!

We’re doing our part to stay apart. We stay at home to protect our loved ones and the most vulnerable in our community. By staying apart, together we can make the world a safer place.`,
        )}
      </span>
      <div className="section-team__wrapper">
        <span className={clsx(Typo.subtitle2, 'section-team__title')}>
          {hasLocizeTranslation(
            t,
            'POMELO_CARE_PINK_GIRLS_HOME_TEAM_TITLE',
            'POMELO TEAM AT HOME:',
          )}
        </span>
        <Timer initialTime={initialTime} serverTime={serverTime} t={t} />
      </div>
      <span className={clsx(Typo.body2, 'text-girls-home-subbody')}>
        {hasLocizeTranslation(
          t,
          'POMELO_CARE_PINK_GIRLS_HOME_SUBBODY',
          'Thank you for staying home with us!',
        )}
      </span>
      <ResponsiveImage
        className="line-home"
        src={STATIC_CONTENTS.lineHome.src}
        imgRatio={STATIC_CONTENTS.lineHome.ratio}
      />
      <ResponsiveImage
        className="images-block"
        src={STATIC_CONTENTS.imagesBlock.src}
        imgRatio={STATIC_CONTENTS.imagesBlock.ratio}
      />
      <div className="text-girls-home-footer">
        {!!lastTextBody[0] && (
          <span className={Typo.body2}>{lastTextBody[0]}</span>
        )}
        {!!lastTextBody[1] && (
          <span className={Typo.subtitle2}>{lastTextBody[1]}</span>
        )}
        {!!lastTextBody[2] && (
          <span className={Typo.body2}>{lastTextBody[2]}</span>
        )}
      </div>
    </section>
  )
}

PinkSection.propTypes = {
  initialTime: PropTypes.shape({
    day: PropTypes.string,
    hour: PropTypes.string,
    minute: PropTypes.string,
    second: PropTypes.string,
  }),
  language: PropTypes.string.isRequired,
  serverTime: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

PinkSection.defaultProps = {
  initialTime: null,
}

export default PinkSection
